<template>
  <div :class="[`bg-${background}`, darkSurfaceBgClass(background), 'w-full']">
    <div class="p-4 lg:p-12">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { darkSurfaceBgClass } from '../../../stores/themeStore.ts'

defineProps({
  background: {
    type: String,
    default: 'white',
  },
})
</script>
